export const SYSTEM_KIND_LABEL = {
  task_reminder: "Task reminder",
  payment_reminder: "Payment reminder",
  sample_reminder: "Sample reminder",
  welcome: "Welcome",
  password_reset: "Password reset",
  file_upload: "New file",
  handled_notice: "Request handled",
  sample_manual_approval: "Sample approved",
  offboarding_kickoff: "Offboarding",
  management_paused: "Management paused",
  management_resumed: "Management resumed",
};

export function isSystemMsg(m) {
  if (m.system_kind || m.reminder || m.payment_reminder ||
      m.sample_reminder || m.welcome || m.file_upload_notification) return true;
  return String(m.sent_by || "").toLowerCase().startsWith("system-");
}

// Split messages into conversation threads (root + replies) and system messages.
export function splitMessages(messages, query = "") {
  const nonSample = messages.filter(m => !m.sample && !m.sample_edits);
  const system = nonSample.filter(isSystemMsg)
    .sort((a, b) => (b.sent_at || "").localeCompare(a.sent_at || ""));
  const convo = nonSample.filter(m => !isSystemMsg(m));
  const ids = new Set(convo.map(m => m.message_id));
  const roots = convo.filter(m => !m.reply_to_message_id || !ids.has(m.reply_to_message_id));
  const repliesOf = (id) => convo.filter(m => m.reply_to_message_id === id)
    .sort((a, b) => (a.sent_at || "").localeCompare(b.sent_at || ""));
  const lastActivity = (r) => repliesOf(r.message_id).reduce(
    (acc, x) => (x.sent_at > acc ? x.sent_at : acc), r.sent_at || "");
  roots.sort((a, b) => (!!b.pinned - !!a.pinned) || lastActivity(b).localeCompare(lastActivity(a)));
  const q = query.trim().toLowerCase();
  if (!q) return { system, roots, repliesOf };
  const hit = (m) => `${m.subject || ""} ${m.body || ""}`.toLowerCase().includes(q);
  return {
    system: system.filter(hit),
    roots: roots.filter(r => hit(r) || repliesOf(r.message_id).some(hit)),
    repliesOf,
  };
}

export function sampleFilesOf(sample, files) {
  const ids = sample.sample_file_ids?.length ? sample.sample_file_ids
    : (sample.sample_file_id ? [sample.sample_file_id] : []);
  return ids.map(id => files.find(f => f.file_id === id)).filter(Boolean);
}
